import { useAuthentication } from '../auth';
import { hasAdminAccess, hasInternalAccess } from '../util/auth';

interface RouteVisibility {
  isClinicsRouteVisible: boolean;
  isAdminRouteVisible: boolean;
  isInternalRouteVisible: boolean;
}

export function useRouteVisibility(): RouteVisibility {
  const currentUser = useAuthentication();
  const isAdmin = hasAdminAccess(currentUser);

  return {
    isClinicsRouteVisible: currentUser.isMultiTenant,
    isAdminRouteVisible: isAdmin,
    isInternalRouteVisible: hasInternalAccess(currentUser)
  };
}
